//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props:['metode', 'keluar'],
    data() {
        return {
            
        }
    },
}
